// // import React, { useMemo, useState } from 'react';
// // import { useSelector } from 'react-redux';
// // import { Box, Tabs, Tab, Paper, Typography } from '@mui/material';

// // import { normalizeRole, getRoleFromCookie } from './workflowApi';
// // import WorkflowQueueTable from './workflowQueueTable';

// // // ── Existing screens — ADJUST THESE IMPORT PATHS to your actual filenames ──
// // import { AdminExcessMasterComponent } from './adminExcessMaster';
// // import ExcessMasterStaffComponent from './staffDocsEpmsModal'; 
// // import CaDashboardComponent from './caEpmsDashboard';
// // import SplocaDashboardComponent from './splocaEpmsDashboard';

// // // role -> ordered list of { key, label, render }
// // const TAB_CONFIG = {
// //   admin: [
// //     { key: 'master', label: 'Excess Master', render: () => <AdminExcessMasterComponent /> },
// //   ],
// //   case_worker: [
// //     { key: 'queue', label: 'My Cases', render: () => <WorkflowQueueTable role="case_worker" title="My Cases" /> },
// //     { key: 'records', label: 'My Records', render: () => <ExcessMasterStaffComponent /> },
// //   ],
// //   forensic_auditor: [
// //     { key: 'queue', label: 'Audit Queue', render: () => <WorkflowQueueTable role="forensic_auditor" title="Audit Queue" /> },
// //   ],
// //   shirastedar: [
// //     { key: 'queue', label: 'Approval Queue', render: () => <WorkflowQueueTable role="shirastedar" title="Shirastedar — Approval Queue" /> },
// //   ],
// //   tahsildar: [
// //     { key: 'queue', label: 'Approval Queue', render: () => <WorkflowQueueTable role="tahsildar" title="Tahsildar — Approval Queue" /> },
// //   ],
// //   assistant_commissioner: [
// //     { key: 'queue', label: 'Approval Queue', render: () => <WorkflowQueueTable role="assistant_commissioner" title="AC — Approval Queue" /> },
// //   ],
// //   competent_authority: [
// //     { key: 'dashboard', label: 'Dashboard', render: () => <CaDashboardComponent /> },
// //     { key: 'queue', label: 'Final Approval Queue', render: () => <WorkflowQueueTable role="competent_authority" title="Final Approval Queue" /> },
// //   ],
// //   sploca: [
// //     { key: 'dashboard', label: 'Dashboard', render: () => <SplocaDashboardComponent /> },
// //     { key: 'queue', label: 'Final Approval Queue', render: () => <WorkflowQueueTable role="sploca" title="Final Approval Queue" /> },
// //   ],
// // };

// // const RoleWorkflowTabs = () => {
// //   // Primary source: redux auth slice (as used elsewhere in this app).
// //   // Fallback: the `user_role` cookie, for the rare case redux hasn't hydrated yet.
// //   const reduxRole = useSelector((s) => s.auth?.role);
// //   const role = normalizeRole(reduxRole || getRoleFromCookie());

// //   const tabs = useMemo(() => TAB_CONFIG[role] || [], [role]);
// //   const [tab, setTab] = useState(0);

// //   if (!tabs.length) {
// //     return (
// //       <Box sx={{ mt: 8, p: 4, textAlign: 'center' }}>
// //         <Typography variant="h6" color="text.secondary">
// //           No EPMS workspace is configured for your role{role ? ` ("${role}")` : ''}.
// //         </Typography>
// //         <Typography variant="body2" color="text.secondary" mt={1}>
// //           Contact an Admin if you believe this is incorrect.
// //         </Typography>
// //       </Box>
// //     );
// //   }

// //   return (
// //     <Box sx={{ width: '100%', mt: 8, mb: 2 }}>
// //       <Paper elevation={1} sx={{ borderRadius: 2, overflow: 'hidden' }}>
// //         <Tabs
// //           value={tab}
// //           onChange={(_, v) => setTab(v)}
// //           variant="scrollable"
// //           scrollButtons="auto"
// //           sx={{
// //             bgcolor: '#1976d2',
// //             '& .MuiTab-root': { color: 'rgba(255,255,255,0.75)', fontWeight: 600 },
// //             '& .Mui-selected': { color: '#fff !important' },
// //             '& .MuiTabs-indicator': { backgroundColor: '#fff', height: 3 },
// //           }}
// //         >
// //           {tabs.map((t) => (
// //             <Tab key={t.key} label={t.label} />
// //           ))}
// //         </Tabs>
// //       </Paper>

// //       <Box mt={2}>
// //         {tabs[tab]?.render()}
// //       </Box>
// //     </Box>
// //   );
// // };

// // export default RoleWorkflowTabs;


// import React, { useMemo, useState } from 'react';
// import { useSelector } from 'react-redux';
// import { Box, Tabs, Tab, Paper, Typography } from '@mui/material';

// import { normalizeRole, getRoleFromCookie } from './workflowApi';
// import WorkflowQueueTable from './workflowQueueTable';
// import MyRecordsTable from './recordsTable';

// // ── Existing screens — ADJUST THESE IMPORT PATHS to your actual filenames ──
// import { AdminExcessMasterComponent } from './adminExcessMaster';
// import CaDashboardComponent from './caEpmsDashboard';
// import SplocaDashboardComponent from './splocaEpmsDashboard';

// // role -> ordered list of { key, label, render }
// // Every role gets a "My Records" tab (full visibility, any stage, full
// // detail) in addition to its actionable queue / existing dashboard.
// const TAB_CONFIG = {
//   admin: [
//     { key: 'master', label: 'Excess Master', render: () => <AdminExcessMasterComponent /> },
//     { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="admin" title="All Records" /> },
//   ],
//   case_worker: [
//     { key: 'queue', label: 'My Cases', render: () => <WorkflowQueueTable role="case_worker" title="My Cases" /> },
//     { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="case_worker" title="My Records" /> },
//   ],
//   forensic_auditor: [
//     { key: 'queue', label: 'Audit Queue', render: () => <WorkflowQueueTable role="forensic_auditor" title="Audit Queue" /> },
//     { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="forensic_auditor" title="My Records" /> },
//   ],
//   shirastedar: [
//     { key: 'queue', label: 'Approval Queue', render: () => <WorkflowQueueTable role="shirastedar" title="Shirastedar — Approval Queue" /> },
//     { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="shirastedar" title="My Records" /> },
//   ],
//   tahsildar: [
//     { key: 'queue', label: 'Approval Queue', render: () => <WorkflowQueueTable role="tahsildar" title="Tahsildar — Approval Queue" /> },
//     { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="tahsildar" title="My Records" /> },
//   ],
//   assistant_commissioner: [
//     { key: 'queue', label: 'Approval Queue', render: () => <WorkflowQueueTable role="assistant_commissioner" title="AC — Approval Queue" /> },
//     { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="assistant_commissioner" title="My Records" /> },
//   ],
//   competent_authority: [
//     { key: 'dashboard', label: 'Dashboard', render: () => <CaDashboardComponent /> },
//     { key: 'queue', label: 'Approval Queue', render: () => <WorkflowQueueTable role="competent_authority" title="CA — Approval Queue" /> },
//     { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="competent_authority" title="My Records" /> },
//   ],
//   sploca: [
//     { key: 'dashboard', label: 'Dashboard', render: () => <SplocaDashboardComponent /> },
//     { key: 'queue', label: 'Final Approval Queue', render: () => <WorkflowQueueTable role="sploca" title="Final Approval Queue" /> },
//     // SPLOCA sees every FE — no scoping applied server-side for this role.
//     { key: 'records', label: 'My Records (All FE)', render: () => <MyRecordsTable role="sploca" title="All Records — All FE" /> },
//   ],
// };

// const RoleWorkflowTabs = () => {
//   // Primary source: redux auth slice (as used elsewhere in this app).
//   // Fallback: the `user_role` cookie, for the rare case redux hasn't hydrated yet.
//   const reduxRole = useSelector((s) => s.auth?.role);
//   const role = normalizeRole(reduxRole || getRoleFromCookie());

//   const tabs = useMemo(() => TAB_CONFIG[role] || [], [role]);
//   const [tab, setTab] = useState(0);

//   if (!tabs.length) {
//     return (
//       <Box sx={{ mt: 8, p: 4, textAlign: 'center' }}>
//         <Typography variant="h6" color="text.secondary">
//           No EPMS workspace is configured for your role{role ? ` ("${role}")` : ''}.
//         </Typography>
//         <Typography variant="body2" color="text.secondary" mt={1}>
//           Contact an Admin if you believe this is incorrect.
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ width: '100%', mt: 8, mb: 2 }}>
//       <Paper elevation={1} sx={{ borderRadius: 2, overflow: 'hidden' }}>
//         <Tabs
//           value={tab}
//           onChange={(_, v) => setTab(v)}
//           variant="scrollable"
//           scrollButtons="auto"
//           sx={{
//             bgcolor: '#1976d2',
//             '& .MuiTab-root': { color: 'rgba(255,255,255,0.75)', fontWeight: 600 },
//             '& .Mui-selected': { color: '#fff !important' },
//             '& .MuiTabs-indicator': { backgroundColor: '#fff', height: 3 },
//           }}
//         >
//           {tabs.map((t) => (
//             <Tab key={t.key} label={t.label} />
//           ))}
//         </Tabs>
//       </Paper>

//       <Box mt={2}>
//         {tabs[tab]?.render()}
//       </Box>
//     </Box>
//   );
// };

// export default RoleWorkflowTabs;


import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Tabs, Tab, Paper, Typography } from '@mui/material';

import { normalizeRole, getRoleFromCookie, STAGES } from './workflowApi';
import WorkflowQueueTable from './workflowQueueTable';
import MyRecordsTable from './recordsTable';

// ── Existing screens — ADJUST THESE IMPORT PATHS to your actual filenames ──
import { AdminExcessMasterComponent } from './adminExcessMaster';
import CaDashboardComponent from './caEpmsDashboard';
import SplocaDashboardComponent from './splocaEpmsDashboard';
import { GenericDashboardComponent } from './genericDashboard';
import WorkflowSettingsPanel from './workflowSettingPanel';



// role -> ordered list of { key, label, render }
// Every role gets: its actionable queue, a separate "Returned" tab (cases
// sent back for correction), and a "My Records" tab (full visibility, any
// stage). Case Worker additionally splits "My Cases" (new submissions) from
// "Payment Settlement" (installments/closure) — these are never merged.
const TAB_CONFIG = {
  admin: [
    { key: 'master', label: 'Excess Master', render: () => <AdminExcessMasterComponent /> },
    // { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="admin" title="All Records" /> },
    { key: 'settings', label: 'Workflow Settings', render: () => <WorkflowSettingsPanel /> },
  ],

  case_worker: [
    { key: 'dashboard', label: 'Dashboard', render: () => <GenericDashboardComponent /> },
    {
      key: 'queue', label: 'My Cases',
      render: () => (
        <WorkflowQueueTable
          role="case_worker" title="My Cases"
          stageOverride={STAGES.PENDING_CASE_WORKER}
          excludeReturned
        />
      ),
    },
    {
      key: 'returned', label: 'Returned',
      render: () => (
        <WorkflowQueueTable
          role="case_worker" title="Returned to Me"
          stageOverride={STAGES.PENDING_CASE_WORKER}
          onlyReturned
        />
      ),
    },
    {
      key: 'payment', label: 'Payment Settlement',
      render: () => (
        <WorkflowQueueTable
          role="case_worker" title="Payment Settlement"
          stageOverride={STAGES.PENDING_PAYMENT}
        />
      ),
    },
    { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="case_worker" title="My Records" /> },
  ],

  joint_secretary: [
    { key: 'dashboard', label: 'Dashboard', render: () => <GenericDashboardComponent /> },
    { key: 'queue', label: 'Approval Queue', render: () => <WorkflowQueueTable role="joint_secretary" title="Joint Secretary — Approval Queue" excludeReturned /> },
    { key: 'returned', label: 'Returned', render: () => <WorkflowQueueTable role="joint_secretary" title="Returned to Me" onlyReturned /> },
    { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="joint_secretary" title="My Records" /> },
  ],

  forensic_auditor: [
    { key: 'queue', label: 'Audit Queue', render: () => <WorkflowQueueTable role="forensic_auditor" title="Audit Queue" excludeReturned /> },
    { key: 'returned', label: 'Returned', render: () => <WorkflowQueueTable role="forensic_auditor" title="Returned to Me" onlyReturned /> },
    { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="forensic_auditor" title="My Records" /> },
  ],

  shirastedar: [
    { key: 'dashboard', label: 'Dashboard', render: () => <GenericDashboardComponent /> },
    { key: 'queue', label: 'Approval Queue', render: () => <WorkflowQueueTable role="shirastedar" title="Shirastedar — Approval Queue" excludeReturned /> },
    { key: 'returned', label: 'Returned', render: () => <WorkflowQueueTable role="shirastedar" title="Returned to Me" onlyReturned /> },
    { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="shirastedar" title="My Records" /> },
  ],

  tahsildar: [
    { key: 'dashboard', label: 'Dashboard', render: () => <GenericDashboardComponent /> },
    { key: 'queue', label: 'Approval Queue', render: () => <WorkflowQueueTable role="tahsildar" title="Tahsildar — Approval Queue" excludeReturned /> },
    { key: 'returned', label: 'Returned', render: () => <WorkflowQueueTable role="tahsildar" title="Returned to Me" onlyReturned /> },
    { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="tahsildar" title="My Records" /> },
  ],

  assistant_commissioner: [
    { key: 'dashboard', label: 'Dashboard', render: () => <GenericDashboardComponent /> },
    { key: 'queue', label: 'Approval Queue', render: () => <WorkflowQueueTable role="assistant_commissioner" title="AC — Approval Queue" excludeReturned /> },
    { key: 'returned', label: 'Returned', render: () => <WorkflowQueueTable role="assistant_commissioner" title="Returned to Me" onlyReturned /> },
    { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="assistant_commissioner" title="My Records" /> },
  ],

  // Competent Authority: sees only their assigned FEs (FeCA) — FE filter
  // dropdown built into WorkflowQueueTable / MyRecordsTable for this role.
  competent_authority: [
    { key: 'dashboard', label: 'Dashboard', render: () => <CaDashboardComponent /> },
    { key: 'queue', label: 'Approval Queue', render: () => <WorkflowQueueTable role="competent_authority" title="CA — Approval Queue" excludeReturned /> },
    { key: 'returned', label: 'Returned', render: () => <WorkflowQueueTable role="competent_authority" title="Returned to Me" onlyReturned /> },
    { key: 'records', label: 'My Records', render: () => <MyRecordsTable role="competent_authority" title="My Records" /> },
  ],

  // SPLOCA: no FE restriction — the FE dropdown still shows (for filtering
  // convenience) but defaults to "All FE (State-wide)".
  sploca: [
    { key: 'dashboard', label: 'Dashboard', render: () => <SplocaDashboardComponent /> },
    { key: 'queue', label: 'Final Approval Queue', render: () => <WorkflowQueueTable role="sploca" title="Final Approval Queue" excludeReturned /> },
    { key: 'returned', label: 'Returned', render: () => <WorkflowQueueTable role="sploca" title="Returned to Me" onlyReturned /> },
    { key: 'records', label: 'My Records (All FE)', render: () => <MyRecordsTable role="sploca" title="All Records — All FE" /> },
  ],
};

const RoleWorkflowTabs = () => {
  // Primary source: redux auth slice (as used elsewhere in this app).
  // Fallback: the `user_role` cookie, for the rare case redux hasn't hydrated yet.
  const reduxRole = useSelector((s) => s.auth?.role);
  const role = normalizeRole(reduxRole || getRoleFromCookie());

  const tabs = useMemo(() => TAB_CONFIG[role] || [], [role]);
  const [tab, setTab] = useState(0);

  if (!tabs.length) {
    return (
      <Box sx={{ mt: 8, p: 4, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          No EPMS workspace is configured for your role{role ? ` ("${role}")` : ''}.
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={1}>
          Contact an Admin if you believe this is incorrect.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', mt: 8, mb: 2 }}>
      <Paper elevation={1} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            bgcolor: '#1976d2',
            '& .MuiTab-root': { color: 'rgba(255,255,255,0.75)', fontWeight: 600 },
            '& .Mui-selected': { color: '#fff !important' },
            '& .MuiTabs-indicator': { backgroundColor: '#fff', height: 3 },
          }}
        >
          {tabs.map((t) => (
            <Tab key={t.key} label={t.label} />
          ))}
        </Tabs>
      </Paper>

      <Box mt={2}>
        {tabs[tab]?.render()}
      </Box>
    </Box>
  );
};

export default RoleWorkflowTabs;